import './contacts-left.styles.scss';
import { CONTACTS_PER_DAY } from '@shared/recruiting.js';
import { midSentence, nextGamesText } from '@/utils/nextGames';

// How many recruiting contacts the manager has left today, and when they
// get new ones (the next game day). `left` from contactsLeft
// (utils/useScouting).
const ContactsLeft = ({ league, left }) => {
    const day = league.season.day ?? 0;
    // Signing day has been played: recruits already decided.
    if (day >= league.season.totalDays) return null;
    const lastDay = day + 1 >= league.season.totalDays;
    const when = midSentence(nextGamesText(league));
    const refill = lastDay ?
        'These are your last contacts: the next game day is signing day, and recruits decide after it.' :
        `You get ${CONTACTS_PER_DAY} new contacts when the next game day is played${when ? `, ${when}` : ''}.`;

    return (
        <div className={`contacts-left ${left === 0 ? 'none' : ''}`} role='status'>
            <div className='contacts-count'>
                <span className='contacts-pips' aria-hidden='true'>
                    {Array.from({ length: CONTACTS_PER_DAY }, (_, i) => <span key={i} className={i < left ? 'on' : ''} />)}
                </span>
                <span>
                    {left > 0 ?
                        <><b>{left}</b> of {CONTACTS_PER_DAY} contact{CONTACTS_PER_DAY === 1 ? '' : 's'} left today</> :
                        <>You&apos;ve used today&apos;s {CONTACTS_PER_DAY} contacts</>}
                </span>
            </div>
            <p className='meta'>{refill}</p>
        </div>
    )
}

export default ContactsLeft
